export default __webpack_public_path__ + "static/media/sequence_models.e48b4e7a.png";